module.exports = __webpack_public_path__ + "img/djj1.ba30ca55.png";